import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Info: FC<ISvG> = ({ fill = "#4f95e8" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.264"
      height="22.265"
      viewBox="0 0 22.264 22.265"
    >
      <g transform="translate(0.1 0.1)">
        <path
          d="M11.032,0A11.032,11.032,0,1,0,22.064,11.032,11.045,11.045,0,0,0,11.032,0Zm0,20.707a9.674,9.674,0,1,1,9.674-9.674A9.685,9.685,0,0,1,11.032,20.707Z"
          fill={fill}
          stroke={fill}
          strokeWidth="0.2"
        />
        <circle
          cx="0.9"
          cy="0.9"
          r="0.9"
          transform="translate(10.5 5.731)"
          fill={fill}
          stroke={fill}
          strokeWidth="0.2"
        />
        <path
          d="M30.845,28.342a.708.708,0,0,0-.708.708v6.015a.708.708,0,0,0,1.415,0V29.05A.708.708,0,0,0,30.845,28.342Z"
          transform="translate(-19.473 -19.313)"
          fill={fill}
          stroke={fill}
          strokeWidth="0.2"
        />
      </g>
    </svg>
  );
};

export default memo(Info);
